import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardMedia from '@material-ui/core/CardMedia'
import FavoriteIcon from '@material-ui/icons/Favorite'
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import IconButton from '@material-ui/core/IconButton'
import MoreVertIcon from '@material-ui/icons/MoreVert'
// import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
// import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
// import { Button } from '@material-ui/core'
import './RecentProjectCardItem.scss'
import Fade from '@material-ui/core/Fade'

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 252,
    marginRight: 24,
    height: 266,
    '&:hover': {
      boxShadow: '0 5px 10px grey',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    cursor: 'pointer'
  },
  media: {
    height: 152,
    width: 252,
    '& svg': {
      height: 152,
      width: 252
    }
  },
  cardTitle: {
    paddingBottom: 11,
    '& .MuiCardHeader-title': {
      // fontFamily: '\'Inter\', sans-serif',
      fontFamily: '\'DIN Pro Light\'',
      fontSize: '1rem',
      fontWeight: 'bold',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      width: '220px',
      whiteSpace: 'nowrap'
    },
    '& .MuiCardHeader-subheader': {
      color: '#485771',
      // fontFamily: '\'Inter\', sans-serif',
      fontFamily: '\'DIN Pro Light\'',
      fontSize: '14px',
      marginTop: 5
    }
  },
  detailsButton: {
    display: 'none',
    color: '#007EB0',
    fontWeight: 600,
    border: 'none',
    padding: 5,
    marginLeft: -6,
    '& .MuiButton-label': {
      fontSize: 14
    }
  },
  mainIcons: {
    color: '#5E6C84'
  },
  menuIcons: {
    color: '#828282',
    width: '0.8em',
    height: '0.8em'
  }
}))


const RecentProjectCardItem = props => {
  const { projectData, userId, deleteProject, onSelectFavorite } = props
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [selectFavorite, deselectFavorite] = React.useState(projectData.isFavorited)

  useEffect(() => {
    if (selectFavorite !== projectData.isFavorited) {
      deselectFavorite(projectData.isFavorited)
    }
  }, [projectData.isFavorited])

  const handleClick = event => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }
  const handleClose = event => {
    event.stopPropagation()
    setAnchorEl(null)
  }

  const deleteActionHandler = e => {
    e.stopPropagation()
    setAnchorEl(null)
    deleteProject({ 'isDeleted': true, selectedProjectId: projectData.id, projectName: projectData.projectName.split('.')[0] })
  }

  const handleFavoriteAction = (event, ...favoriteObj) => {
    event.stopPropagation()
    deselectFavorite(!selectFavorite)
    onSelectFavorite({ favorite: favoriteObj[0], userId: favoriteObj[1], projectId: favoriteObj[2] })
  }

  return (
    <Fade in={true} timeout={500}>
      <Card className={classes.root}
        data-testid="recent-project-card"
        onClick={props.onClick}
      >
        <CardMedia
          className={classes.media}
          image={projectData.signedUrl ? projectData.signedUrl : '/images/no_photo_big.svg'}
          title={projectData.projectName}
        />
        <CardHeader
          className={classes.cardTitle}
          title={projectData.projectName}
          subheader={`Deal ID: ${projectData.dealNumber}`}
        />
        <div className="details-action-buttons">
          <div className="details">
            {/* <Button className={classes.detailsButton}>
              <InfoOutlinedIcon />
              <span className="details-text">DETAILS</span>
            </Button> */}
          </div>
          <div className="action-buttons">
            <IconButton data-testid={`favorite-icon-${projectData.id}`} onClick={e => handleFavoriteAction(e, false, userId, projectData.id)}>
              {selectFavorite && (
                <FavoriteIcon className={classes.mainIcons} />
              )}
            </IconButton>
            <IconButton data-testid={`unfavorite-icon-${projectData.id}`} onClick={e => handleFavoriteAction(e, true, userId, projectData.id)}>
              {!selectFavorite && (
                <FavoriteBorderIcon className={classes.mainIcons} />
              )}
            </IconButton>
            <div className="vertical-menu-icon">
              <IconButton
                aria-controls="card-menu"
                aria-haspopup="true"
                data-testid="card-menu"
                onClick={handleClick}
              >
                <MoreVertIcon className={classes.mainIcons} />
              </IconButton>
              <Menu
                id="recent-card-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                data-testid="recent-project-card-menu"
              >
                {/* <MenuItem onClick={handleClose}>
                  <EditIcon className={classes.menuIcons} />
                  <span className="menu-item" data-testid="rename">Rename</span>
                </MenuItem> */}
                <MenuItem disabled={(userId !== projectData.createdUserGuid)} onClick={e => deleteActionHandler(e)}>
                  <DeleteIcon className={classes.menuIcons} />
                  <span className="menu-item" data-testid="delete1">Delete</span>
                </MenuItem>
              </Menu>
            </div>
          </div>
        </div>
      </Card>
    </Fade>
  )
}

RecentProjectCardItem.propTypes = {
  onClick: PropTypes.func,
  projectData: PropTypes.object,
  userId: PropTypes.string,
  deleteProject: PropTypes.func,
  onSelectFavorite: PropTypes.func
}
export default RecentProjectCardItem
